/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-07-22 16:49:58
 * @LastEditors: WangQi
 * @LastEditTime: 2022-10-28 11:04:17
 */
// 推广加热
const map = {
  deliveryDemandList: () => import('@/views/popularizationHeating/DeliveryDemandList'), // 投放需求表
  launchDataEffect: () => import('@/views/popularizationHeating/LaunchDataEffect'), // 投放数据效果表
  promoteHeatingChargeImport: () => import('@/views/popularizationHeating/PromoteHeatingChargeImport'), // 推广加热费用导入
  celebPromoteDouHeat: () => import('@/views/popularizationHeating/CelebPromoteDouHeat'), // Dou+加热明细认领异常报表
  getPomoteAuthorizeInfo: () => import('@/views/popularizationHeating/GetPomoteAuthorizeInfo') // 视频授权对接表

}

export default map
